import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalGuard, MsalService } from '@azure/msal-angular';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { BaseService } from 'projects/Autofacets-Core/src/app/services/base.service';
import { Observable, Subscription } from 'rxjs';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { UserDataService } from './../../../../../../src/app/DataServices/user-data.service';
import * as fromConstants from './../../../../../Autofacets-Core/src/app/utils/constant';
import { Submenu } from './../../business-entities/vertical-menu-item.model';


@Injectable({
    providedIn: 'root'
})
export class RoleAccessGuard  {
    currentUserRoleDetails: UserRoleMenu[];
    loginSub: Subscription;
    access:boolean;
    constructor(
        private router: Router,
        private userService: UserDataService,
        private msalService: MsalService,
        private baseService: BaseService,
        private currentLanguageService: CurrentLanguage,
        private _authGuard: MsalGuard
    ) { }

    canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return this.canActivateChild(childRoute, state);


    }

     canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree>
         {

            let hasAccess = false;
            const routesData = fromConstants.VerticalMenu.reduce<Submenu[]>((previousEle, currentEle) => {
                if (!(currentEle.submenu === null || currentEle.submenu === undefined)) {
                    previousEle = previousEle.concat(currentEle.submenu);
                }
                else if(currentEle.parentsubmenu){
                    currentEle.parentsubmenu.forEach(element => {
                        if(!(element.submenu === null || element.submenu === undefined)){
                            previousEle = previousEle.concat(element.submenu);
                        }
                    });
                }
                else {
                    previousEle.push({ id: currentEle.id, name: currentEle.name, lable: currentEle.lable, route: currentEle.route });
                }
                return previousEle;
            }, []);

            this.baseService.userLoggedIn = this.currentLanguageService.userLoggedIn.getValue()
           //(x => {

                if(this.baseService.userLoggedIn)
                {
                    if (this.userService.currentUserValue === undefined) {
                        return this.userService.GetUserDetails().then(
                            _response => {
                                this.currentUserRoleDetails = this.userService.currentUserValue.userRoleMenuDetails;
                                if (this.userService.currentUserValue.isCorrectRole) {
                                    const routeIndexFromPath = routesData.findIndex(x => x.route === `/${state.url.split('/')[1]}`);
                                    if (routeIndexFromPath !== -1) {
                                        const moduleId = routesData[routeIndexFromPath].id;
                                        if(moduleId !== fromConstants.Constant.DashBoardModuleId){
                                            if(this.isLicenseKeyExpired()){
                                                const redirectRoute = routesData.find(x => x.id === fromConstants.Constant.DashBoardModuleId).route;
                                                return this.router.createUrlTree([`/${redirectRoute}`]);
                                            }
                                        }
                                        const roleDetailsIndex = this.currentUserRoleDetails.findIndex(x => x.moduleId === moduleId);
                                        if (roleDetailsIndex !== -1) {
                                            const roleDetails = this.currentUserRoleDetails[roleDetailsIndex];
                                            if (childRoute.data.isMain) {
                                                hasAccess = roleDetails.canView;
                                            } else if (childRoute.data.isEdit) {
                                                hasAccess = roleDetails.canEdit;
                                            } else if (childRoute.data.isAdd) {
                                                hasAccess = roleDetails.canAdd;
                                            } else if (childRoute.data.isModule) {
                                                hasAccess = true;
                                            }
                                        }
                                    }
                                    if (hasAccess) {
                                        return true;
                                    } else {
                                        const moduleId = this.currentUserRoleDetails[0].moduleId;
                                        const redirectRoute = routesData.find(x => x.id === moduleId).route;
                                        return this.router.createUrlTree([`/${redirectRoute}`]);
                                    }
                                } else if (!this.userService.currentUserValue.isCorrectRole) {
                                    this.msalService.logout();
                                }
                            });
                    } else if (this.userService.currentUserValue !== null) {
                        this.currentUserRoleDetails = this.userService.currentUserValue.userRoleMenuDetails;
                        if (this.userService.currentUserValue.isCorrectRole) {
                            const routeIndexFromPath = routesData.findIndex(x => x.route === `/${state.url.split('/')[1]}`);
                            if (routeIndexFromPath !== -1) {
                                const moduleId = routesData[routeIndexFromPath].id;
                                if(moduleId !== fromConstants.Constant.DashBoardModuleId){
                                    if(this.isLicenseKeyExpired()){
                                        const redirectRoute = routesData.find(x => x.id === fromConstants.Constant.DashBoardModuleId).route;
                                        return this.router.createUrlTree([`/${redirectRoute}`]);
                                    }
                                }
                                const roleDetailsIndex = this.currentUserRoleDetails.findIndex(x => x.moduleId === moduleId);
                                if (roleDetailsIndex !== -1) {
                                    const roleDetails = this.currentUserRoleDetails[roleDetailsIndex];
                                    if (childRoute.data.isMain) {
                                        hasAccess = roleDetails.canView;
                                    } else if (childRoute.data.isEdit) {
                                        hasAccess = roleDetails.canEdit;
                                    } else if (childRoute.data.isAdd) {
                                        hasAccess = roleDetails.canAdd;
                                    } else if (childRoute.data.isModule) {
                                        hasAccess = true;
                                    }
                                }
                            }
                            if (hasAccess) {
                                return true;
                            } else {
                                const moduleId = this.currentUserRoleDetails[0].moduleId;
                                const redirectRoute = routesData.find(x => x.id === moduleId).route;
                                return this.router.createUrlTree([`/${redirectRoute}`]);
                            }
                        } else if (!this.userService.currentUserValue.isCorrectRole) {
                            this.msalService.logout();
                        }
                     }
                }
                // else {
                //     return this.router.createUrlTree([`/`]);
                // }
             // })
            //  this.currentLanguageService.userLoggedIn.pipe(take(1)).subscribe(value => this.access = value);
             // return this.access

              if (hasAccess) {
                return true;
            } else {

                    return this.router.createUrlTree([`/`]);

            }
       }
       isLicenseKeyExpired(){
        if (  this.userService?.currentUserValue?.isLicenseKeyExpired) {
            return true;
          }
          return false;
       }
   // }
}
